import { useExteriorSectionData } from '../useExteriorSection';
import { useLevel1SectionData } from '../useLevel1Section';

export const useOBDSections = () => {
  const { subSections: interiorSubSections } = useLevel1SectionData('interior_questions');
  const { subSections: tiresSubSections } = useExteriorSectionData('tires');

  return [
    interiorSubSections.title_issues,
    tiresSubSections.vin_plate,
    tiresSubSections.license_plate_registration
  ].filter(Boolean);
};
